var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H8C9.10457 22 10 21.1046 10 20V4C10 2.89543 9.10457 2 8 2ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H8C10.2091 24 12 22.2091 12 20V4C12 1.79086 10.2091 0 8 0H4ZM20 2H17C15.8954 2 15 2.89543 15 4V7C15 8.10457 15.8954 9 17 9H20C21.1046 9 22 8.10457 22 7V4C22 2.89543 21.1046 2 20 2ZM17 0C14.7909 0 13 1.79086 13 4V7C13 9.20914 14.7909 11 17 11H20C22.2091 11 24 9.20914 24 7V4C24 1.79086 22.2091 0 20 0H17ZM17 15H20C21.1046 15 22 15.8954 22 17V20C22 21.1046 21.1046 22 20 22H17C15.8954 22 15 21.1046 15 20V17C15 15.8954 15.8954 15 17 15ZM13 17C13 14.7909 14.7909 13 17 13H20C22.2091 13 24 14.7909 24 17V20C24 22.2091 22.2091 24 20 24H17C14.7909 24 13 22.2091 13 20V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHover);
export default __webpack_public_path__ + "static/media/dashboard-hover.8b91a7999fcf1efef8f6ceba5f9c5272.svg";
export { ForwardRef as ReactComponent };